import classNames from 'classnames'
import { Visibility } from 'globalTypes'

import { gql, useQuery } from '@apollo/client'
import { IconName, library } from '@fortawesome/fontawesome-svg-core'
import { faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getItemVisibility } from 'lib/get-item-visibility'

import styles from './index.module.css'

library.add(faLock, faLockOpen)

interface ItemVisibilityProps {
  id: string
  iconClassName?: string
  visibility?: Visibility
  wrapperClassName?: string
}

const GET_ELEMENT_VISIBILITY = gql`
  query GetElementVisibility($id: ID!) {
    element(id: $id) {
      __typename

      ... on Collection {
        id
        visibility
        need_registration
      }

      ... on Content {
        id
        visibility
        need_registration
      }

      ... on Folder {
        id
        visibility
      }
    }
  }
`

const ItemVisibility = ({
  id,
  iconClassName,
  visibility,
  wrapperClassName,
}: ItemVisibilityProps) => {
  const { data, loading } = useQuery(GET_ELEMENT_VISIBILITY, {
    variables: {
      id: id,
    },
    fetchPolicy: 'cache-first',
  })

  const curVisibility = getItemVisibility(
    data?.element?.visibility,
    data?.element?.need_registration
  )

  const icons = {
    [Visibility.public]: 'globe',
    [Visibility.preview]: 'globe',
    [Visibility.protected]: 'users',
    [Visibility.private]: 'users',
    [Visibility.mine]: 'user',
    need_registration: 'user-plus',
  }

  const customWrapperClass = wrapperClassName
    ? wrapperClassName
    : styles.iconWrapperDefault

  const customIconClass = iconClassName ? iconClassName : styles.iconDefault

  return (
    <span
      className={classNames([
        styles.iconWrapper,
        customWrapperClass,
        { 'animate-pulse': loading },
      ])}
    >
      {curVisibility && (
        <FontAwesomeIcon
          icon={['fas', icons[curVisibility] as IconName]}
          className={customIconClass}
        />
      )}
    </span>
  )
}

export default ItemVisibility
